function RSVP(el) {
	var t = this;
	t.el = el;
	t.body = document.body;
	t.content = el.querySelector('.js-rsvp-content');
	t.activeButton = document.querySelector('.js-rsvp-open');
	t.overlay = document.querySelector('.js-rsvp-overlay');

	if( t.activeButton ) {
		t.activeButton.addEventListener('click', function() {
			t.body.classList.add('js-rsvp-active');
		});
	}

	t.overlay.addEventListener('click', function() {
		t.body.classList.remove('js-rsvp-active');
	});

}
module.exports = RSVP;
